import PropTypes from 'prop-types';
import React from 'react';

import './RedText.css';


function RedText({text}) {
  return (
    <p className='RedText'>
      {text}
    </p>
  );
}

RedText.propTypes = {
  text: PropTypes.string.isRequired,
};

export default RedText;



// WEBPACK FOOTER //
// ./src/components/Intake/Custom/RedText.js